import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    textAlign: 'left'
  }
}))

const ButtonLink = ({ onClick, children }) => {
  const classes = useStyles();
  return (
    <Link
      className={classes.root}
      component="button"
      variant="body2"
      onClick={onClick}
    >{children}</Link>
  )
}

export default ButtonLink;